/**
 * RTWO Indexer Engine — Null Ledger Adapter
 */

import type {
  AddressIndexAdapterResult,
  AssetIndexAdapterResult,
  ILedgerAdapter,
  LedgerAdapterStatus,
  TransactionIndexAdapterResult,
} from './ledger-adapter-interface';

export class NullLedgerAdapter implements ILedgerAdapter {
  readonly adapterId = 'null-ledger-adapter';
  readonly adapterName = 'Null Ledger Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): LedgerAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async indexTransaction(_transactionHash: string): Promise<TransactionIndexAdapterResult | null> {
    return null;
  }

  async indexAddress(_address: string): Promise<AddressIndexAdapterResult | null> {
    return null;
  }

  async indexAsset(_assetId: string): Promise<AssetIndexAdapterResult | null> {
    return null;
  }
}
